import { render } from "./SchedaProgetto.vue?vue&type=template&id=b22213b4&scoped=true"
import script from "./SchedaProgetto.vue?vue&type=script&lang=js"
export * from "./SchedaProgetto.vue?vue&type=script&lang=js"

import "./SchedaProgetto.vue?vue&type=style&index=0&id=b22213b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b22213b4"]])

export default __exports__